var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.079H25V23.5C25 24.6046 24.1046 25.5 23 25.5H11C9.89543 25.5 9 24.6046 9 23.5V17.079Z",
    fill: "#FCA66C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8945 13.2895V9.5H19.1051V13.2895L16.9998 12.0263L14.8945 13.2895Z",
    fill: "#FCA66C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 25.5H11C9.89543 25.5 9 24.6046 9 23.5V17.5V11.5C9 10.3954 9.89543 9.5 11 9.5H13.2105H23C24.1046 9.5 25 10.3954 25 11.5V13.2895V18.3421",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2291 2.65517C7.02392 4.35086 2.45459 10.1307 2.45459 17C2.45459 23.8693 7.02392 29.6491 13.2291 31.3448M13.2291 2.65517L12.5245 5.96552M13.2291 2.65517L10.2868 1",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3566 31.3749C26.8004 29.7101 31.5454 24.0353 31.5454 17.2909C31.5454 10.5465 26.8004 4.87176 20.3566 3.2069M20.3566 31.3749L21.0882 28.1248M20.3566 31.3749L23.412 33",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressing);
export default __webpack_public_path__ + "static/media/Progressing.998a69b5158090acdeadc8126d751977.svg";
export { ForwardRef as ReactComponent };